import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="B" transform="translate(11.000000, 5.000000)">
        <path
          d="M25 30.663h9.401l6.481 6.483v6.981L30.307 33.608l-.033 19.361H25z"
          fill="currentColor"
          transform="scale(1.30) translate(-8 -8)"
        />
        <path
          d="M48.631 52.969h-9.399l-6.48-6.484V39.501l10.575 10.517.032-19.356h5.272z"
          fill="currentColor"
          transform="scale(1.30) translate(-8 -8)"
        />
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
